import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';

const COGNIA_LOGO = '/cognia_seal.png';

export default function CogniaBanner() {
  const { language } = useLanguage();

  return (
    <section data-testid="cognia-banner" className="bg-[#14274B] py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex items-center justify-center gap-4 sm:gap-6"
        >
          <div className="flex-shrink-0">
            <img
              src={COGNIA_LOGO}
              alt="COGNIA — Accréditation internationale école bilingue"
              className="h-10 sm:h-12 w-auto"
              data-testid="cognia-banner-logo"
            />
          </div>
          <div className="border-l border-white/20 pl-4 sm:pl-6">
            <p
              className="text-white font-semibold text-sm sm:text-base"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {language === 'fr' ? 'Accrédité COGNIA' : 'COGNIA Accredited'}
            </p>
            <p
              className="text-white/60 text-xs sm:text-sm"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {language === 'fr'
                ? '40 000 établissements · 100+ pays · 17 millions d\'élèves'
                : '40,000 institutions · 100+ countries · 17 million students'}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
